import React from "react";
import { Card } from "./Card";
import { Badge } from "./Badge";
import { Button } from "./Button";
import {
  UsersIcon,
  ClipboardDocumentListIcon,
  MapPinIcon,
  PencilIcon,
  CreditCardIcon,
} from "@heroicons/react/24/outline";

const ClubCard = ({ club, onEdit }) => {
  return (
    <Card className="hover:shadow-md transition-shadow">
      <div className="p-6">
        <div className="flex justify-between items-start mb-4">
          <div>
            <h3 className="text-lg font-semibold text-gray-900">{club.name}</h3>
            <div className="flex items-center text-gray-600 text-sm mt-1">
              <MapPinIcon className="w-4 h-4 mr-1" />
              {club.location}
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <Badge variant={club.status === "active" ? "success" : "gray"}>
              {club.status}
            </Badge>
            {onEdit && (
              <Button
                variant="secondary"
                size="sm"
                onClick={() => onEdit(club)}
                className="p-2"
              >
                <PencilIcon className="w-4 h-4" />
              </Button>
            )}
          </div>
        </div>

        <div className="space-y-3">
          <div className="flex items-center justify-between text-sm">
            <div className="flex items-center text-gray-600">
              <UsersIcon className="w-4 h-4 mr-2" />
              <span>Players: {club.player_count || 0}</span>
            </div>
            <div className="flex items-center text-gray-600">
              <ClipboardDocumentListIcon className="w-4 h-4 mr-2" />
              <span>Evaluations: {club.active_evaluations || 0}</span>
            </div>
          </div>

          {club.subscription_plan && (
            <div className="flex items-center justify-between text-sm pt-2 border-t border-gray-200">
              <div className="flex items-center text-gray-600">
                <CreditCardIcon className="w-4 h-4 mr-2" />
                <span>Plan:</span>
              </div>
              <Badge variant="blue">{club.subscription_plan}</Badge>
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};

export { ClubCard };
